export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <>
      {" "}
      <div className="kis-footer dont-show-in-print">
        <div className="flex items-center text-black">
          <div className="flex flex-col">
            The Victorian Government Department of Education. Copyright &copy; {currentYear}. All rights reserved Kindergarten Inclusion Support.
          </div>
        </div>
        <div className="flex flex-row items-center">
          <i className="pi pi-envelope mx-2"></i>
          <span className="mr-2">support@kisapplications.com.au </span> <span className="mx-2">|</span>
          <i className="pi pi-phone mx-2"></i> <span>1300 564 149</span>
        </div>
      </div>{" "}
      <div className="print-last-page hidden">
        <div className="flex flex-col">
          The Victorian Government Department of Education. Copyright &copy; {currentYear}. All rights reserved Kindergarten Inclusion Support.
        </div>
      </div>
    </>
  );
}
